<script>
import LoadingTemplate from "@/components/widgets/loading-template.vue";
import UploadPopover from "@/components/widgets/upload-popover.vue";
import Swal from "sweetalert2";

export default {
    name: 'FinanceAttachments',
    components: {
        LoadingTemplate,
        UploadPopover
    },
    props: {
        wActions: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            attachments: [],
            lastId: 0,
            loading: false,
            uploadOpt: {},
            attachmentId: 0,
            attachmentPV: false,
            filter: '',
            journalRefType: null,
        };
    },
    computed: {
        filtered(){
            return this.attachments.filter((x) => {
                return x.filterKey.toLowerCase().includes(this.filter.toLowerCase());
            });
        }
    },
    methods: {
        async getFiles(type, id){
            return await this.$store
                .dispatch("filemanager/GetFiles", {id, type, removeLoading: true})
                .then((res) => {
                    if(res.data.error){
                        return [];
                    }
                    return res.data;
                })
                .catch(() => {
                    return [];
                });
        },
        async getJournal(id){
            await this.$store
                .dispatch("journalentry/getSingleJournalEntry", id)
                .then((res) => {
                    if(res.data.error){
                        return this.lastId = 0;
                    }
                    this.lastId = res.data.referenceId;
                    this.journalRefType = res.data.referenceType;
                })
                .catch(() => {
                    return this.lastId = 0;
                });
        },
        async getDV(id){
            await this.$store
                .dispatch("disbursement/getSingleDisbursement", id)
                .then((res) => {
                    if(res.data.error){
                        return this.lastId = 0;
                    }
                    this.lastId = res.data.bursId;
                })
                .catch(() => {
                    return this.lastId = 0;
                });
        },
        async getBurs(id){
            await this.$store
                .dispatch("burs/getSingleBurs", id)
                .then((res) => {
                    if(res.data.error){
                        return this.lastId = 0;
                    }
                    this.lastId = res.data.rfpId;
                })
                .catch(() => {
                    return this.lastId = 0;
                });
        },
        async getRFP(id){
            await this.$store
                .dispatch("rfppo/GetSingleRfpPo", id)
                .then((res) => {
                    if(res.data.error){
                        return this.lastId = 0;
                    }
                    this.lastId = res.data.poId;
                })
                .catch(() => {
                    return this.lastId = 0;
                });
        },
        async getPO(id){
            await this.$store
                .dispatch("po/GetSinglePo", id)
                .then((res) => {
                    if(res.data.error){
                        return this.lastId = 0;
                    }
                    this.lastId = res.data.rfqSupplier.rfqId;
                })
                .catch(() => {
                    return this.lastId = 0;
                });
        },
        async getRFQ(id){
            await this.$store
                .dispatch("rfq/GetSingleRfq", id)
                .then((res) => {
                    if(res.data.error){
                        return this.lastId = 0;
                    }
                    console.log(res.data);
                    this.lastId = 0;
                    // this.lastId = res.data.rfqSupplierId;
                })
                .catch(() => {
                    return this.lastId = 0;
                });
        },
        pushToAttachments(files, type){
            if(files.length){
                let filterKey = type;
                files.map(x => {
                    filterKey += ` ${x.description}`;
                })
                this.attachments.push({
                    type: type,
                    files: files,
                    filterKey: filterKey
                });
            }
        },
        async getAttachments(att, id){
            this.attachments = [];
            this.loading = true;
            this.lastId = id;
            this.attachmentId = id;
            if(this.lastId != 0 && att.includes('rcd')){
                let files = await this.getFiles('RCD', this.lastId);
                this.lastId = 0;
                this.pushToAttachments(files, 'RCD Attachments');
            }
            if(this.lastId != 0 && att.includes('journal')){
                let files = await this.getFiles('Journal', this.lastId);
                await this.getJournal(this.lastId);
                this.pushToAttachments(files, 'Journal Attachments');
            }
            if(this.lastId != 0 && att.includes('jev')){
                let files = await this.getFiles('JEV', this.lastId);
                this.pushToAttachments(files, 'JEV Attachments');
            }
            if(this.lastId != 0 && att.includes('dv')){
                let files = await this.getFiles('Disbursement', this.lastId);
                await this.getDV(this.lastId);
                this.pushToAttachments(files, 'Disbursement Attachments');
            }
            if(this.lastId != 0 && att.includes('burs')){
                let files = await this.getFiles('BURS', this.lastId);
                await this.getBurs(this.lastId);
                this.pushToAttachments(files, 'BURS/OBRS Attachments');
            }
            if(this.lastId != 0 && att.includes('rfp')){
                let files = await this.getFiles('RFP P.O', this.lastId);
                await this.getRFP(this.lastId);
                this.pushToAttachments(files, 'Disbursement Request Attachments');
            }
            if(this.lastId != 0 && att.includes('po')){
                let poFiles = await this.getFiles('Purchase Order', this.lastId);
                await this.getPO(this.lastId);
                this.pushToAttachments(poFiles, 'P.O Attachments');
                
                let rfqFiles = await this.getFiles('Bids & Quotations', this.lastId);
                await this.getRFQ(this.lastId);
                this.pushToAttachments(rfqFiles, 'RFQ Attachments');
            }
            this.loading = false;
        },
        setUploadOpt(opt){
            this.uploadOpt = opt;
        },
        uploadedDocument(response) {
            let type = '';
            if(this.uploadOpt.type == 'BURS'){
                type = 'BURS/OBRS Attachments';
            }else if(this.uploadOpt.type == 'Disbursement'){
                type = 'Disbursement Attachments';
            }else if(this.uploadOpt.type == 'RFP P.O'){
                type = 'Disbursement Request Attachments';
            }else if(this.uploadOpt.type == 'JEV'){
                type = 'JEV Attachments';
            }else if(this.uploadOpt.type == 'Journal'){
                type = 'Journal Attachments';
            } else if(this.uploadOpt.type == 'RCD'){
                type = 'RCD Attachments';
            }
            let index = this.attachments.findIndex(x => x.type == type);
            let filterKey = type;
            response.filterKey = `${type} ${response.description}`;
            if(index > -1){
                this.attachments[index].files.push(response);
                this.attachments[index].files.map(x => {
                    filterKey += ` ${x.description}`;
                })
                this.attachments[index].filterKey = filterKey;
                return;
            }else{
                filterKey += ` ${response.description}`;
            }
            this.attachments.push({
                type: type,
                files: [response],
                filterKey: filterKey
            });
        },
        removeFile(id) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("filemanager/DeleteFile", id)
                        .then((res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, "error");
                            }
                            let typeIndex = this.attachments.findIndex(x => x.files.some(f => f.id == id));
                            if(typeIndex > -1){
                                let fileIndex = this.attachments[typeIndex].files.findIndex(f => f.id == id);
                                if(fileIndex > -1){
                                    this.attachments[typeIndex].files.splice(fileIndex, 1);
                                    let filterKey = this.attachments[typeIndex].type;
                                    this.attachments[typeIndex].files.map(x => {
                                        filterKey += ` ${x.description}`;
                                    })
                                    this.attachments[typeIndex].filterKey = filterKey;
                                    if(this.attachments[typeIndex].files.length == 0){
                                        this.attachments.splice(typeIndex, 1);
                                    }
                                }
                            }
                            this.showToast('Successfully removed!', "success");
                        })
                        .catch(() => {
                            this.showToast('Cannot be remove!', "error");
                        });
                }
            });
        },
        openDocument(x) {
            this.readFile(x.id)
        },
        canDelete(x){
            if(x.type == 'Disbursement Attachments' && this.uploadOpt.type == 'Disbursement'){
                return true;
            }
            if(x.type == 'BURS/OBRS Attachments' && this.uploadOpt.type == 'BURS'){
                return true;
            }
            if(x.type == 'Disbursement Request Attachments' && this.uploadOpt.type == 'RFP P.O'){
                return true;
            }
            if(x.type == 'JEV Attachments' && this.uploadOpt.type == 'JEV'){
                return true;
            }
            if(x.type == 'Journal Attachments' && this.uploadOpt.type == 'Journal'){
                return true;
            }
            if(x.type == 'RCD Attachments' && this.uploadOpt.type == 'RCD'){
                return true;
            }
            return false;
        }
    }
};
</script>
<template>
    <b-modal
        id="finance-attachment-modal"
        title="Attachments"
        size="lg"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <div class="row mb-3">
            <div class="col-md-6">
                <input type="search" class="form-control form-control" placeholder="Search Attachments" v-model="filter">
            </div>
            <div class="col-md-6 text-right">
                <div v-if="wActions">
                    <b-button variant="success" @click="attachmentPV = true"  :id="`target-attachment-${attachmentId}`">
                        <i class="fa fa-upload"></i> Upload
                    </b-button>
                    <upload-popover
                        :option="uploadOpt"
                        :sourceId="attachmentId"
                        @uploaded="uploadedDocument($event)"
                        :showPV="attachmentPV"
                        @closePopover="attachmentPV = false"
                        :dzId="`dropzone-target${attachmentId}`"
                        :pvId="`target-attachment-${attachmentId}`"
                    ></upload-popover>
                </div>
            </div>
        </div>
        <div v-for="(x, ind) in filtered" :key="ind">
            <h5 class="mb-0 text-white">{{x.type}}:</h5>
            <div class="row mb-2">
                <div class="col-md-6" v-for="y in x.files" :key="y.id">
                    <div class="position-relative cursor-pointer border mt-2 br-5">
                        <div class="border p-3">
                            <div>
                                <div class="float-end ms-2">
                                    <b-dropdown
                                        id="dropdown-dropleft"
                                        right
                                        variant="link"
                                        toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                                        menu-class="dropdown-menu-end"
                                        no-caret
                                    >
                                        <template #button-content>
                                            <i class="mdi mdi-dots-horizontal"></i>
                                        </template>
                                        <b-dropdown-item
                                            @click="openDocument(y)"
                                            ><i class="bx bx-link-external me-1"></i>Open</b-dropdown-item
                                        >
                                        <b-dropdown-item variant="danger" @click="removeFile(y.id)" v-if="wActions && canDelete(x)"
                                            ><i class="bx bx-trash me-1"></i>Remove</b-dropdown-item
                                        >
                                    </b-dropdown>
                                </div>
                                <div
                                    class="
                                        avatar-xs
                                        me-3
                                        mb-2
                                    "
                                    @click="openDocument(y)"
                                >
                                    <div
                                        class="
                                            avatar-title
                                            bg-transparent
                                            rounded
                                        "
                                    >
                                        <i
                                            v-if="y.fileType.includes('image')"
                                            class="
                                                mdi mdi-image
                                                font-size-24
                                                text-purple
                                            "
                                        ></i>
                                        <i
                                            v-if="y.fileType.includes('application')"
                                            class="
                                                mdi mdi-file-pdf-outline
                                                font-size-24
                                                text-danger
                                            "
                                        ></i>
                                    </div>
                                </div>
                                <div
                                    class="
                                        d-flex
                                    "
                                    @click="openDocument(y)"
                                >
                                    <div
                                        class="
                                            overflow-hidden
                                            me-auto
                                        "
                                    >
                                        <h5
                                            class="
                                                font-size-14
                                                text-truncate
                                                mb-1
                                            "
                                        >
                                            {{y.description}}
                                        </h5>
                                        <p
                                            class="
                                                text-muted
                                                mb-0
                                            "
                                        >
                                            {{formatDateWithTime(new Date(y.dateTimeUploaded))}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="loading" class="my-4">
            <LoadingTemplate />
        </div>
        <div v-if="!loading && !attachments.length">
            <div class="text-center my-4">
                <h5 class="mt-3">No Attachments.</h5>
            </div>
        </div>
    </b-modal>
</template>